import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { IRevenueDataModel, IRevenueParams } from '../interfaces/revenue-data';

@Injectable({
    providedIn: 'root',
})
export class RevenueService {
    private serverUrl = 'https://' + window.location.host;
    private version = '0.5';
    private _url = (this.serverUrl + '/api/v{version}/branchrevenue/').replace(
        '{version}',
        this.version
    );
    private hasRouteHistory = false;

    constructor(private _http: HttpClient) {}

    getRevenueEntityData(parameters: IRevenueParams): Observable<IRevenueDataModel[]> {
        return this._http.post<IRevenueDataModel[]>(
            this._url + 'getEntityRevenueTrend',
            parameters,
            {
                headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
            }
        );
    }
}
